import { NotificationEntryDto } from '../state/notification.store';

/**
 * Creates a route to a deliverable with query params for use in [routerLink] and [queryParams].
 * Example path: http://localhost:4200/projects/143/deliverables-status/1949/profile/tag-index?packageId=9265&deliverableStatusTab=all-deliverables
 */
export function getDeliverableRouterLink(
  data: Pick<
    NotificationEntryDto,
    'projectId' | 'deliverableId' | 'deliverableType' | 'trimPackageId' | 'profileId'
  >,
): { route: any[]; queryParams: {} } {
  return {
    route: ['/projects', data.projectId, 'deliverables-status', data.deliverableId, 'profile'],
    queryParams: {
      versionId: data.profileId,
      packageId: data.trimPackageId,
      deliverableStatusTab: 'all-deliverables',
    },
  };
}
